export default __webpack_public_path__ + "static/media/ble_bridge.840a85c7.jpg";